import React, { useEffect, useState } from 'react'
import { sendSegmentTrackEvent } from 'services/segment'
import { useTranslation } from 'react-i18next'
import { useMutation } from 'react-query'
import styled from 'styled-components'

import { ToggleButton } from '@junglescout/edna'

import { useSelectedAmazonSellerAccount } from 'hooks/amazon_seller_account'
import { useNotification } from 'hooks/notification'
import { productType } from 'types/product_costs_and_settings'

const StyledText = styled.div`
  padding-left: 8px;
`
const ButtonWrapper = styled.span`
  height: 20px;
`

export const VisibleCell = ({ product }) => {
  const { t } = useTranslation('product_costs_and_settings')
  const createNotification = useNotification()

  const { amazon_seller_account_id } = useSelectedAmazonSellerAccount()

  const [toggleValue, setToggleValue] = useState(
    product.enabled || product.enabled_toggle === 'all_on'
  )

  const reverseOnError = async () => {
    product.enabled = !toggleValue
    await setToggleValue(product.enabled)
  }

  useEffect(() => {
    setToggleValue(product.enabled || product.enabled_toggle === 'all_on')
  }, [product])

  const { mutate: toggleVisible } = useMutation(
    'api/junglekit/product/update',
    {
      onSuccess: () => {
        createNotification({
          title: 'Success!',
          message: t(
            'product_costs_and_settings:visibilitysuccessfullyupdated',
            'Product visibility was successfully updated'
          ),
          level: 'success'
        })

        sendSegmentTrackEvent('CTA Clicked', {
          text: 'Visible in Jungle Scout Toggle',
          location: 'Product Settings',
          section: 'Product table',
          ASIN: product.asin,
          setToStatus: toggleValue ? 'On' : 'Off'
        })
      },
      onError: error => {
        reverseOnError()
        createNotification({
          title: 'Error',
          message: error?.error,
          level: 'error'
        })
      }
    }
  )

  const updateProductVisibility = () => {
    toggleVisible({
      data: {
        amazon_seller_account_id,
        enabled: product.enabled,
        product_id: product.product_id,
        type: 'child'
      },
      method: 'PATCH'
    })
  }

  const flipToggle = async e => {
    e.stopPropagation()
    /* eslint no-param-reassign: "error" */
    product.enabled = !toggleValue
    await setToggleValue(product.enabled)
    updateProductVisibility()
  }

  const hidden = t('product_costs_and_settings:hidden', 'Hidden')
  const visible = t('product_costs_and_settings:visible', 'Visible')

  return (
    <>
      <ButtonWrapper onClick={flipToggle}>
        <ToggleButton checked={toggleValue} />
      </ButtonWrapper>
      <StyledText>{toggleValue ? visible : hidden}</StyledText>
    </>
  )
}

VisibleCell.propTypes = {
  product: productType.isRequired
}
